export default __webpack_public_path__ + "static/SR India - ISO 14001- Certificate-379103f5e191fe92b5fee1b5b319e114.pdf";